import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor() { }

  validateEmailWithRegex(email) {
    let emailRegexExp = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{1,})$/i;
      if (!emailRegexExp.test(email)){
        return true;
      }else {
        return false;
      }
  }
}
